<template>
  <div id="svg-container">
    <svg :id="id"></svg>
    <div class="mt-auto" style="background-color: transparent;">
      <div class="row">
        <div class="col-lg-1">
          <!-- pulsante prev -->
          <div style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="prevMethod" ><i class="fa fa-angle-left" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);"></i>&nbsp;PREV</div>
        </div>
        <div class="col-lg-2">
          <!-- spazio vuoto a sinistra della scrollbar/slider -->
        </div>
        <div class="col-lg-6">
          <svg :id="`scroll_${id}`"></svg>
        </div>
        <div class="col-lg-2">
          <div v-if="!(globalBarWidth == maxZoom && !isScroll)">
            <!-- zoom -->
            <i class="fa fa-search-minus" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="zoomOut" v-if="globalBarWidth > minZoom"></i>
            <span style="color: rgb(54, 96, 121);">&nbsp;ZOOM&nbsp;</span>
            <i class="fa fa-search-plus" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="zoomIn" v-if="globalBarWidth < maxZoom"></i>
          </div>
        </div>
        <div class="col-lg-1">
          <!-- pulsante next -->
          <div style="cursor: pointer; color: rgb(54, 96, 121);" @click.prevent="nextMethod" >NEXT&nbsp;<i class="fa fa-angle-right" aria-hidden="true" style="cursor: pointer; color: rgb(54, 96, 121);"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import _ from "lodash";
import jquery from 'jquery';

const margin = 50;

export default {
  props: ["issues","graphicTitle","router","route-name","propertyName","filtroRicerca","um","prevMethod","nextMethod","labelInclination","filterDB","code","count"],
  data() {
    return {
      id: null,
      chart: null,
      scrollChart: null,
      isScroll: null,
      noDataSentence: null,
      globalBarWidth: null,
      minZoom: 20,
      maxZoom: 30,
      jquery,
      svg: null,
      svgScroll: null,
      scrollTotalWidth: null,
      totalWidth: null,
      doRender: true,
    };
  },
  watch: {
    issues(val) {
      if (this.chart != null) this.chart.remove();
      if (this.scrollChart != null) this.scrollChart.remove();
      if (this.noDataSentence != null) this.noDataSentence.remove();
      this.renderChart();
    }
  },
  computed: {
    sign() {
      return (this.um !== null && this.um != undefined) ? this.um : "";
    }
  },
  methods: {
    renderChart() {
      const chartId = this.id;
      this.doRender = this.issues !== undefined && this.issues !== null && this.issues.length > 0;
      if (this.issues !== undefined && this.issues.length >= 0) {
        this.doRender = this.issues.filter(e => e.value != undefined && parseInt(e.value) > 0).length > 0;
      }
      if (this.issues !== undefined) {
        this.svg = d3
          .select("#" + this.id)
          .attr("class", "chart")
          .attr("width", "100%")
          .attr("height", "97%");
        
        this.svgScroll = d3
          .select("#scroll_" + this.id)
          .attr("class", "scrollchart-container")
          .attr("width", "100%")
          .attr("height", "20");

        jquery(".data-tooltip").remove();
        var tooltip = jquery("<div></div>").addClass("chart-tooltip data-tooltip");
        tooltip.hide();
        jquery("body").append(tooltip);
  
        if (this.chart) {
          this.chart.remove();
        }

        if (this.scrollChart) {
          this.scrollChart.remove();
        }
  
        window.addEventListener("resize", this.drawFunction);

        this.drawFunction();
      }
    },
    zoomed({transform}) {
      this._zoomed(transform);
    },
    _zoomed(transform) {
      transform.y = 0;
      d3.select("#" + this.id)
        .select("g")
        .attr("transform", transform);
    },
    display(event) {
      var x = parseInt(this.svgScroll.select(".mover").attr("x")),
        nx = x + event.dx,
        w = parseInt(this.svgScroll.select(".mover").attr("width"));
      if ( nx < 0 || nx + w > this.scrollTotalWidth ) return;
      this.svgScroll.select(".mover").attr("x", nx);

      var dx = -1 * parseInt((nx / this.scrollTotalWidth) * this.totalWidth);
      var t = d3.zoomIdentity.translate(margin + dx, 0).scale(1);
      this._zoomed(t);
    },
    drawFunction() {
      console.log("draw " + this.graphicTitle);
      const bounds = this.svg.node().getBoundingClientRect();

      if (bounds === undefined || bounds.width == 0 || bounds.height == 0) {
        return;
      } 

      const chartWidth = bounds.width - 2*margin;
      const chartHeight = bounds.height - margin;

      this.svg.selectChild("g").remove();
      this.svg.selectChild("defs").remove(); 

      this.svgScroll.selectChild("g").remove();

      var data = this.issues;
      let items = this.issues.length;

      if (this.globalBarWidth === undefined || this.globalBarWidth === null) {
        this.globalBarWidth = this.maxZoom;
      }
      const barWidth = this.globalBarWidth;

      const colors = d3.scaleOrdinal().domain(data).range(["#366079", "#679dba"])

      this.chart = this.svg
        .append("g")
        .attr("transform", `translate(${margin}, 0)`);

      this.scrollChart = this.svgScroll
        .append("g");

      if (this.noDataSentence) {
        this.noDataSentence.remove();
      }
      if (!this.doRender) {
        this.noDataSentence = this.svg
          .append("text")
          .text("Non ci sono dati da rappresentare")
          .attr("x", chartWidth/2 + margin)
          .attr("y", chartHeight/2 - 2*margin)
          .style("font-size", "2rem")
          .style("fill", "#366079")
          .style("text-anchor", "middle");

        this.isScroll = false;
        this.svgScroll.attr("class", "no-scroll");

        return;
      }

      const yScale = d3
        .scaleLinear()
        .range([chartHeight, 0])
        .domain([0, Number(_.maxBy(data, function(o) { return Number(o.value); }).value) + 1]);

      var xScaleRange = items * barWidth;
      //var xxScale = d3.scale.ordinal().rangeRoundBands([chartWidth / 2 - xScaleRange, chartWidth / 2 + xScaleRange], 0.2);

      let xRange = [chartWidth / 2 - xScaleRange, chartWidth / 2 + xScaleRange];
      if (xRange[0] < 0) {
        xRange[1] = xRange[1] - xRange[0];
        xRange[0] = 0;
      }

      const xScale = d3
        .scaleBand()
        .range(xRange)
        .domain(data.map(s => s.description))
        .padding(0.2);

      const xAxis = d3.axisBottom(xScale);
      this.chart
        .append("g")
        .attr("class", "axis x-axis")
        .attr("transform", `translate(0, ${chartHeight})`)
        .call(xAxis);

      var clip = this.svg.append('defs')
        .append('clipPath')
        .attr('id', 'clip')
        .append('rect')
        .attr('x', 0)
        .attr('y', 0)
        .attr('width', chartWidth)
        .attr('height', chartHeight);

      var scatter = this.chart
        .append('g')
        .attr("clip-path", "url(#clip)")

      // drawing bars
      const barGroups = this.chart
        .selectAll("rect")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("x", g => xScale(g.description))
        .attr("y", g => yScale(g.value))
        .attr("height", g => chartHeight - yScale(g.value))
        .attr("width", xScale.bandwidth())
        .attr("fill", function(d, i){
          return colors(i%2) 
        })
        .on("mouseover", (event, d) => {
          d3.select(event.currentTarget)
            .attr("stroke-width", 3)
            .attr("stroke", "red")
            .attr("cursor", "pointer");

          const t = `${d.description} : ${d.value}${this.sign}`;
          jquery(".data-tooltip")
            .html(t)
            .css("left", (event.pageX) + "px")
            .css("top", (event.pageY - 28) + "px")
            .show(200);
        })
        .on("mouseout", function() {
          d3.select(event.currentTarget)
            .attr("stroke", "none")
            .attr("cursor", "default");

          jquery(".data-tooltip").hide();
        })
        .on("click", (d,i) => {
          const code = (i.code != undefined && i.code != "") ? i.code : this.code;
          var f = {
            key: this.propertyName,
            value: undefined,
            values: [{code: code, description: i.description}],
            count: this.count,
          }
          if (!Array.isArray(this.filtroRicerca[this.propertyName])) {
            f.value = {code: code, description: i.description};
            f.values = undefined;
          }
          this.filterDB(f);
          /*
          if (Array.isArray(this.filtroRicerca[this.propertyName]) == true) {
            this.filtroRicerca[this.propertyName] = [{code: i.code, description: i.description}];
          } else {
            this.filtroRicerca[this.propertyName] = i.code;
          }

          this.router.push({ name: this.routeName, params: { filters: this.filtroRicerca} });
          */
        });

      this.chart
        .selectAll("text .item-label")
        .data(data)
        .enter()
        .append("text")
        .attr("class", "item-label")
        .text((d) => {
          return d.value + this.sign;
        })
        .attr("x", function(d, i) {
          return xScale(d.description);
        })
        .attr("y", function(d) {
          const h = chartHeight - yScale(d.value)
          if (h < 20) {
            return yScale(d.value) - 10;  
          }
          return yScale(d.value) + 15;
        })
        .attr("dx", xScale.bandwidth() / 2)
        .attr("font-size", "12px")
        .attr("fill", function (d) {
          const h = chartHeight - yScale(d.value)
          if (h < 20) {
            return "black";
          }
          return "white";
        })
        .attr("text-anchor", "middle")
        .attr("dominant-baseline", "central");

      // adding labels
      /*let t = graphicTitle + (this.issues.length > items ? ` (solo i primi ${items} elementi)` : "");
      this.chart
        .append('text')
        .attr('class', 'title')
        .attr('x', chartWidth / 2 + margin)
        .attr('y', 40)
        .attr('text-anchor', 'middle')
        .attr('stroke', '#366079')
        .style("text-shadow", "none")
        .text(t)*/

      // insertLinebreaks
      /*
      let insertLinebreaks = function(d) {
        const maxRowChars = 7;

        if (typeof(d) === "string" && d.length > maxRowChars) {
          let el = d3.select(this);
          el.text('');

          let words1 = d.split(' ');

          let words2 = [];
          for (let i = 0; i < words1.length; i++) {
            if (words1[i].includes('+') ) {
              const words1Parts = words1[i].split('+');
              words1Parts.forEach(w => {
                words2.push(w);
                words2.push('+');
              });
              words2.pop();
            } else {
              words2.push(words1[i]);
            }
          }

          // aggrego le parole in modo che la loro concatenazione non superi maxRowChars
          let aggregateWords = [];
          let aggregateWordsIndex = 0;
          let concatWords = "";
          for (let i = 0; i < words2.length; i++) {
            let isLastIndex = (i == words2.length-1);

            let tempConcatWords = "";
            if (concatWords.length == 0) {
              tempConcatWords = words2[i];
            } else  {
              tempConcatWords = concatWords + " " + words2[i];
            }

            if (tempConcatWords.length > maxRowChars || isLastIndex) {
              aggregateWords[aggregateWordsIndex] = isLastIndex ? tempConcatWords : concatWords;
              aggregateWordsIndex++;
              concatWords = words2[i];
            } else {
              concatWords = tempConcatWords;
            }
          }

          for (let i = 0; i < aggregateWords.length; i++) {
            let tspan = el.append('tspan').text(aggregateWords[i]);
            if (i > 0)
              tspan.attr('x', 0).attr('dy', '15');
          }
        }
      }
      */

      // labelInclination
      let localLabelInclination = this.labelInclination;
      if (localLabelInclination === undefined || localLabelInclination === null) {
        localLabelInclination = true;
      }

      this.svg.selectAll('.x-axis g.tick text')
        .each(function() {
          const maxLabelLength = 25;
          let self = d3.select(this);
          let textLength = self.text().length;
          let text = self.text();
          if (textLength > maxLabelLength) {
            text = text.slice(0, maxLabelLength);
            self.text(text + '...');
          }
        })
        .attr("y", 0)
        .attr("x", () => {
          let shift = 10;
          if (!localLabelInclination) {
            shift = 0;
          }
          return shift;
        })
        .attr("dy", "1.5em")
        .attr("dx", () => {
          let shift = "-0.5em";
          if (!localLabelInclination) {
            shift = "0em";
          }
          return shift;
        })
        .attr("transform", () => {
          let rotateVal = "rotate(15)";
          if (!localLabelInclination) {
            rotateVal = "rotate(0)";
          }
          return rotateVal;
        })
        .style("text-anchor", () => {
          let textAnchor = "start";
          if (!localLabelInclination) {
            textAnchor = "middle";
          }
          return textAnchor;
        });

      const zoom = d3.zoom()
        .scaleExtent([1, 1])
        .on("zoom", this.zoomed);

      //this.svg.call(zoom);

      let lastBar = this.svg.selectAll(".bar").filter(function() {
        return this.nextElementSibling.className.baseVal != "bar";
      });
      this.totalWidth = parseFloat(lastBar.attr("x")) + parseFloat(lastBar.attr("width"));
      
      let scrollBounds = this.svgScroll.node().getBoundingClientRect();
      this.scrollTotalWidth = scrollBounds.width;
      let scrollWidth = chartWidth * this.scrollTotalWidth / this.totalWidth - margin/4;
      if (chartWidth < this.totalWidth) {
        this.isScroll = true;
        this.svgScroll.attr("class", "scrollchart-container");

        this.scrollChart.append("rect")
          .attr("class", "mover")
          .attr("x", 0)
          .attr("y", 0)
          .attr("height", "20")
          .attr("width", Math.round(scrollWidth))
          .attr("pointer-events", "all")
          .attr("cursor", "ew-resize")
          .call(d3.drag().on("drag", this.display));
      } else {
        this.isScroll = false;
        this.svgScroll.attr("class", "no-scroll");
      }

      if (!(this.globalBarWidth == this.maxZoom && !this.isScroll)) {
        const zIn = this.zoomIn;
        const zOut = this.zoomOut;
        this.svg.on("mousewheel.zoom", function(event) {
          if (event.deltaY < 0) {
            zIn();
          } else if (event.deltaY > 0) {
            zOut();
          }
          event.preventDefault();
        });
      } else {
        this.svg.on('mousewheel.zoom', null)
      }
    },    
    zoomIn() {
      this.globalBarWidth += 2;
      this.globalBarWidth = this.globalBarWidth > this.maxZoom ? this.maxZoom : this.globalBarWidth;
      this.drawFunction();
    },
    zoomOut() {
      this.globalBarWidth -= 2;
      this.globalBarWidth = this.globalBarWidth < this.minZoom ? this.minZoom : this.globalBarWidth;
      this.drawFunction();
    }
  },
  created() {
    this.id = "uid" + this._uid;
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    jquery(".data-tooltip").remove();
    if (this.chart) {
      this.chart.remove();
    }
    if (this.scrollChart) {
      this.scrollChart.remove();
    }
    window.removeEventListener("resize", this.drawFunction);
  },
};
</script>

<style lang="scss">
#svg-container {
  height: 100%;
}
</style>
